export const LOG_RECORD_REQUEST = 'LOG_RECORD_REQUEST';
export const LOG_RECORD_SUCCESS = 'LOG_RECORD_SUCCESS';
export const LOG_RECORD_FAIL = 'LOG_RECORD_FAIL';
export const LOG_RECORD_IDLE = 'LOG_RECORD_IDLE';

export const EXPORT_LOG_RECORD_REQUEST = 'EXPORT_LOG_RECORD_REQUEST';
export const EXPORT_LOG_RECORD_SUCCESS = 'EXPORT_LOG_RECORD_SUCCESS';
export const EXPORT_LOG_RECORD_FAIL = 'EXPORT_LOG_RECORD_FAIL';
export const EXPORT_LOG_RECORD_IDLE = 'EXPORT_LOG_RECORD_IDLE';
